import { render, staticRenderFns } from "./ELTextarea.vue?vue&type=template&id=217f9d4a"
import script from "./ELTextarea.vue?vue&type=script&lang=js"
export * from "./ELTextarea.vue?vue&type=script&lang=js"
import style0 from "./ELTextarea.vue?vue&type=style&index=0&id=217f9d4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports